module.exports = __webpack_public_path__ + "static/aghacks-e6e3373a8cc2e6312aca5334b3a021cc.png";